import { CharacteristicsItemWrapper, CharacteristicsKey, CharacteristicsValue, CharacteristicsWrapper, CharacteristicsUnit } from './styles';

const Characteristics = ({ characteristics }) => {
  const shouldRenderEmptyCharacteristicsWrapper = !characteristics && Object.keys(characteristics).length !== 0;

  if (shouldRenderEmptyCharacteristicsWrapper) {
    return <CharacteristicsWrapper />;
  }

  const characteristicKeys = Object.keys(characteristics);

  return (
    <CharacteristicsWrapper>
      {characteristicKeys.map((characteristicKey) => (
        <CharacteristicsItemWrapper key={characteristicKey}>
          <CharacteristicsKey>{`${characteristics[characteristicKey].name}:`}</CharacteristicsKey>
          <CharacteristicsValue>{characteristics[characteristicKey].value}</CharacteristicsValue>
          <CharacteristicsUnit>{characteristics[characteristicKey].unit}</CharacteristicsUnit>
        </CharacteristicsItemWrapper>
      ))}
    </CharacteristicsWrapper>
  );
};

export default Characteristics;
